import { PLANOGRAM_CONFIG, WIDTH } from 'shared/config/PlanogramConfig';
import { Arithmetic, CylinderPoint } from 'shared/utils/modulo.util';
import type { Vector } from 'shared/utils/modulo.util';
import { toFractionDigits } from './float-util';

export type PlanogramWidth = typeof WIDTH;
export const planogramWidth: PlanogramWidth = WIDTH;
export const planogramArithmetic = new Arithmetic(WIDTH);

export default class PlanogramPoint<
  V extends Vector = Vector
> extends CylinderPoint<PlanogramWidth> {
  constructor(position?: V) {
    super(planogramWidth);
    if (position) this.set(position.x, position.y);
    else this.set(0, 0);
  }
}

export function flipEditorY(y: number): number {
  return PLANOGRAM_CONFIG.height / 2 + PLANOGRAM_CONFIG.virtualSphereY - y;
}

export function toEditorPosition(point: PlanogramPoint): [string, string] {
  return [toFractionDigits(point.x, 2), toFractionDigits(flipEditorY(point.y), 2)];
}

export function fromEditorPosition(point: [string, string]): PlanogramPoint {
  const [x, y] = point.map(parseFloat);
  return new PlanogramPoint().set(x, flipEditorY(y));
}
